import(/* webpackMode: "eager", webpackExports: ["SectionHeader","SectionEnd"] */ "/vercel/path0/components/ui/SectionHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GroundObject"] */ "/vercel/path0/components/visual/scene/GroundObject.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
